<template>
  <v-row class="pt-5" v-if="content">
    <v-col cols="10" offset="1">
      <v-row
        v-for="row in content.exercise_today_tomorrow.questions"
        :key="row.title"
      >
        <v-col cols="12" offset="0">
          <h2 class="text-h5">{{ row.title }}</h2>
        </v-col>

        <v-col cols="6">
          <results-card
            v-model="results.matrix[row.today.model]"
            :limit="20"
            :name="row.today.name"
            num=""
            :title="row.today.title"
            description=""
            color="amber"
            bgColor="#494949"
            svg="wing-left-new@2x.png"
            :reverse="false"
          >
          </results-card>
        </v-col>
        <v-col cols="6">
          <results-card
            v-model="results.matrix[row.tomorrow.model]"
            :limit="20"
            :name="row.tomorrow.name"
            num=""
            :title="row.tomorrow.title"
            description=""
            color="amber"
            bgColor="#494949"
            svg="wing-right-new@2x.png"
            :reverse="true"
          >
          </results-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import ResultsCard from "@/components/results/today-tomorrow/ResultsCard";

import { mapState } from "vuex";

export default {
  name: "ResultsTodatTomorrowUser",
  components: {
    ResultsCard,
  },
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },
  data() {
    return {
      content: null,
      results: null,
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getExercise() {
      this.doc = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.todayTomorrowExCollection
        .where("pid", "==", this.id)
        .where("uid", "==", this.uid);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.results = items[0].doc;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
